import { Hero } from '../components/sections/Hero';
import { Services } from '../components/sections/Services';
import { Portfolio } from '../components/sections/Portfolio';
import { Testimonials } from '../components/sections/Testimonials';
import { WhyChooseUs } from '../components/sections/Why-choose-us';
import { About } from '../components/sections/About';
import { CoreValues } from '../components/sections/CoreValues';
import { WhyChooseAyonk } from '../components/sections/WhyChooseAyonk';
import { OurClients } from '../components/sections/OurClients';

export function Home() {
    return (
        <main>
            <Hero />
            <Portfolio />
            <Services />
            <WhyChooseUs />
            <Testimonials />
            <About />
            <CoreValues />
            <WhyChooseAyonk />
            <OurClients />
        </main>
    );
}
